var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAN0lEQVR42mMYBTQGjMHnzoAw2ZoZLCaAMYhNnmbNfBCGG0KKZqwYJEdQM2FM2CVpxODRJEZFAADwRjlJt1uaXwAAAABJRU5ErkJggg==";
  export default img;